import { useCallback, useEffect, useRef, useState } from "react";

export const TOAST_MS = 3600;
const TONES = ["ok", "warn", "bad", "info"];

// One message at a time: a new say() replaces whatever is showing. A message
// with actions ([{ label, onClick }]) stays up longer, since it asks for a choice.
export const ACTION_TOAST_MS = 9000;
export default function useToast(ms = TOAST_MS) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);
  const seq = useRef(0);

  const clear = useCallback(() => {
    clearTimeout(timer.current);
    timer.current = null;
    setToast(null);
  }, []);

  const say = useCallback(
    (text, tone = "info", actions = null) => {
      clearTimeout(timer.current);
      timer.current = null;
      if (!text) {
        setToast(null);
        return;
      }
      seq.current += 1;
      const acts = Array.isArray(actions) ? actions.filter((a) => a?.label && typeof a.onClick === "function").slice(0, 3) : [];
      setToast({ id: seq.current, text, tone: TONES.includes(tone) ? tone : "info", actions: acts });
      const wait = acts.length ? Math.max(ms, ACTION_TOAST_MS) : ms;
      if (ms > 0) timer.current = setTimeout(() => setToast(null), wait);
    },
    [ms]
  );

  useEffect(() => () => clearTimeout(timer.current), []);

  return { toast, say, clear };
}
